export default "__VITE_ASSET__OI5yfQpC__"